// extracted by mini-css-extract-plugin
module.exports = {"root":"HollywoodTitle_root__BOW0I"};